import {
    postFindByCondition,
    postFindLogByCondition,
    postSendSMSToHolder
} from "./api/holdernotify"

class HolderNotifyService{
    async sendSMSToHolder(_message, _holders){
        var params = {
            sms_log: {
                message: _message,
                holders: _holders
            }
        }
        try {
            console.log(params,'HolderNotifyService.sendSMSToHolder' )
            const result = await postSendSMSToHolder(params)
            return result
        } catch (err) {
            return err
        } 
    }

    async findBySmsLogId(sms_log_id){
        try{
            var data = { 
                query_data:{
                    type: 'query',
                    query_options: [{
                        queryField: 'sms_log_id',
                        queryType: '=',
                        queryData: sms_log_id
                        }
                    ],
                    pagination:{
                        itemsPerPage: 1000
                    }
                }
            }
            const result = await postFindByCondition(1, data)
            return result
        } catch (err) {
            return err
        }
    }

    async findByCondition(_holder_id,_holder_name, page, itemsPerPage){
        try{
            var data = this.getParams(_holder_id,_holder_name, itemsPerPage);
            const result = await postFindByCondition(page, data)
            return result
        } catch (err) {
            return err
        } 
    }

    getParams(_holder_id, _holder_name, itemsPerPage){
        var data={} 
        if (_holder_id == null) _holder_id = '';
        if (_holder_name == null) _holder_name = '';
        if (_holder_id == '' && _holder_name == ''){
            //是否分頁
            if (itemsPerPage!=null) {
                data = { 
                    query_data:{
                        type: 'all',
                        query_options: [],
                        pagination:{
                            itemsPerPage: itemsPerPage
                        }
                    }
                }
            } else {
                data = { 
                    query_data:{
                        type: 'all',
                        query_options: []
                    }
                }
            }
        } else {
            //是否分頁
            if (itemsPerPage!=null) {
                data = { 
                    query_data:{
                        type: 'query',
                        query_options: [],
                        pagination:{
                            itemsPerPage: itemsPerPage
                        }
                    }
                }
            } else {
                data = { 
                    query_data:{
                        type: 'query',
                        query_options: []
                    }
                }
            }

            if (_holder_name != '') {
                data.query_data.query_options.push({
                    queryField: 'holder',
                    queryType: 'like',
                    queryData: _holder_name + '%'
                });
            }

            if (_holder_id != '') {
                data.query_data.query_options.push({
                    queryField: 'holder_id',
                    queryType: '=',
                    queryData: _holder_id
                });
            }
        }
        return data
    }

    async findLogByCondition(_user_id, page, itemsPerPage){
        try{
            var data = this.getFindLogParams(_user_id, itemsPerPage);
            const result = await postFindLogByCondition(page,data)
            return result
        } catch (err) {
            return err
        } 
    }

    getFindLogParams(_user_id, itemsPerPage){
        var data={} 
        if (_user_id == null) _user_id = '';
        if (_user_id == ''){
            //是否分頁
            if (itemsPerPage!=null) {
                data = { 
                    query_data:{
                        type: 'all',
                        query_options: [],
                        pagination:{
                            itemsPerPage: itemsPerPage
                        }
                    }
                }
            } else {
                data = { 
                    query_data:{
                        type: 'all',
                        query_options: []
                    }
                }
            }
        } else {
            //是否分頁
            if (itemsPerPage!=null) {
                data = { 
                    query_data:{
                        type: 'query',
                        query_options: [],
                        pagination:{
                            itemsPerPage: itemsPerPage
                        }
                    }
                }
            } else {
                data = { 
                    query_data:{
                        type: 'query',
                        query_options: []
                    }
                }
            }

            if (_user_id != '') {
                data.query_data.query_options.push({
                    queryField: 'user_id',
                    queryType: '=',
                    queryData: _user_id
                });
            }
        }
        return data
    }
}

export default new HolderNotifyService();